mutation UpsertProductLineFromConsole(
    $productLine: ProductLineInput!
) {
    upsertProductLine(
        productLine: $productLine
    ) {
        id

        brand {
            id
        }
        key

        name {
            language
            text
        }

        image

        parameterIDs
        position
    }
}
